export default {
  data() {
    return {
      mobileDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.order.col,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.order.col,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
        {
          title: this.$t("dropdowns.sortingBy"),
          options: [
            {
              label: this.$t("templateSnippets.name"),
              key: "name",
              method: () => {
                this.sortTemplateSnippets(
                  "name",
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.updated_at"),
              key: "updated_at",
              method: () => {
                this.sortTemplateSnippets(
                  "updated_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.created_at"),
              key: "created_at",
              method: () => {
                this.sortTemplateSnippets(
                  "created_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      sortMainColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          key: "name",
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortTemplateSnippets("name", "ASC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortTemplateSnippets("name", "DESC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsFirstColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.showAs.firstCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.showAs.firstCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("templateSnippets.type"),
              key: "status",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    firstCol: {
                      label: "templateSnippets.type",
                      key: "status",
                      format: "templateSnippetsType",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.updated_at"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    firstCol: {
                      label: "templateSnippets.updated_at",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.created_at"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    firstCol: {
                      label: "templateSnippets.created_at",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsSecondColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.showAs.secondCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.showAs.secondCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("templateSnippets.default"),
              key: "status",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    secondCol: {
                      label: "templateSnippets.default",
                      key: "status",
                      format: "templateSnippetsDefault",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.updated_at"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    secondCol: {
                      label: "templateSnippets.updated_at",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.created_at"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    secondCol: {
                      label: "templateSnippets.created_at",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsThirdColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.showAs.thirdCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortTemplateSnippets(
                  this.teamsSettings[this.$route.params.team].listsSettings.templateSnippets.showAs.thirdCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("templateSnippets.updated_at"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    thirdCol: {
                      label: "templateSnippets.updated_at",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("templateSnippets.created_at"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "templateSnippets",
                  showAs: {
                    thirdCol: {
                      label: "templateSnippets.created_at",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      filterDropdown: [
        {
          title: this.$t("filters.filterTemplateSnippets"),
          options: [
            {
              label: this.$t("filters.isText"),
              switch: {
                name: "is_text",
                model: true,
              },
              checkbox: true,
              method: () => {},
              hoverBg: true,
            },
            {
              label: this.$t("filters.isEmail"),
              switch: {
                name: "is_email",
                model: true,
              },
              checkbox: true,
              method: () => {},
              hoverBg: true,
            },
            {
              label: this.$t("filters.isDefault"),
              switch: {
                name: "is_default",
                model: true,
              },
              checkbox: true,
              method: () => {},
              hoverBg: true,
            },
            {
              label: this.$t("filters.activateFilter"),
              border: "border-top",
              color: "primary",
              position: "center",
              method: () => {
                this.setTemplateSnippetsFilters();
              },
              noActiveState: true,
              button: true,
            },
            {
              label: this.$t("filters.resetFilter"),
              color: "text-danger",
              position: "center",
              method: () => {
                this.resetFilters(this.setTemplateSnippetsFilters);
              },
              hoverBg: true,
              noActiveState: true,
            },
          ],
        },
      ],
    };
  },
};
